"use client";

import { Link } from "@/i18n/routing";
import { GoogleSignInIcon, IconRegister } from "@repo/assets/images";
import { PageTitle } from "@repo/components";
import { REGISTER_FORM_FIELDS } from "@repo/constants/account";
import { useAuth, useRegister } from "@repo/lib/hooks/account";
import { Button, ErrorMessage, Input, InputPassword, LoadingDots } from "@repo/ui";
import cx from "classnames";
import { useTranslations } from "next-intl";
const RegisterForm = props => {
  const {
    variant = "primary",
    handleCheckoutSignIn
  } = props || {};
  const isGoogleLoginAvailable = process.env.NEXT_PUBLIC_IS_SOCIAL_LOGIN_AVAILABLE ?? false;
  const tCommon = useTranslations("Common");
  const tAccount = useTranslations("Account");
  const {
    handleSubmit,
    handleValidation,
    formErrors,
    formValues,
    isPending
  } = useRegister({
    variant,
    handleCheckoutSignIn
  });
  const {
    handleSocialSubmit,
    isSocialLoginPending
  } = useAuth(variant, handleCheckoutSignIn);
  return <form onSubmit={handleSubmit} data-sentry-component="RegisterForm" data-sentry-source-file="RegisterForm.jsx">
      <div className="mx-auto max-w-[630px] px-4 py-[22px] md:px-0">
        {variant !== "secondary" && <div className="space-y-2 py-10 text-center">
            <PageTitle title={tCommon("Registration")} variant="small" />
          </div>}
        <div className="mb-6 grid grid-cols-1 gap-y-4 md:grid-cols-2 md:gap-x-4">
          {REGISTER_FORM_FIELDS?.map(({
          id,
          type,
          name,
          placeholder,
          label,
          readOnly,
          disabled
        }) => <div key={id}>
                {type === "password" ? <InputPassword name={name} placeholder={tCommon(placeholder)} value={formValues?.[name]} onChange={handleValidation} readOnly={readOnly} disabled={disabled} label={tCommon(label)} /> : <Input type={type} name={name} placeholder={tCommon(placeholder)} value={formValues?.[name]} onChange={handleValidation} readOnly={readOnly} disabled={disabled} label={tCommon(label)} />}
                <ErrorMessage message={formErrors?.[name]} />
              </div>)}
        </div>
        <div className="text-center">
          <div className={cx("", {
          "flex flex-col": isGoogleLoginAvailable
        })}>
            <Button size="md" type="submit" className="mb-3 w-full" variant="primary" disabled={isPending} data-sentry-element="Button" data-sentry-source-file="RegisterForm.jsx">
              {isPending ? <LoadingDots className="bg-white" /> : <span className="inline-flex items-center gap-2 whitespace-nowrap">
                  <IconRegister /> {tCommon("Register")}
                </span>}
            </Button>
            {isGoogleLoginAvailable && <Button type="button" size="md" className="w-full" variant="secondary" onClick={() => handleSocialSubmit("google")}>
                {isSocialLoginPending ? <LoadingDots className="bg-gray-800" /> : <span className="inline-flex items-center gap-2 whitespace-nowrap">
                    <GoogleSignInIcon />
                    {tCommon("Login_With_Google")}
                  </span>}
              </Button>}
          </div>
          {variant !== "secondary" && <>
              <p className="py-3 font-medium">
                {tCommon("By_Registering_Text")}{" "}
                <Link href="/cms/terms" className="text-anchor-text hover:text-anchor-hover hover:underline">
                  T&amp;C&apos;s
                </Link>
              </p>
              <p className="border-supportiveDarkGray border-t py-3 font-medium">
                {tAccount("Already_Have_An_Account")}{" "}
                <Link href="/login" className="text-anchor-text hover:text-anchor-hover hover:underline">
                  {tCommon("Login")}
                </Link>
              </p>
            </>}
        </div>
      </div>
    </form>;
};
export default RegisterForm;